import moment from 'moment';

import {
  GET_AGENDA_LIST,
  GET_AGENDA_LIST_SUCCESS,
  SET_AGENDA_LIST_LOADING,
  GET_AGENDA_DETAILS,
  GET_AGENDA_DETAILS_SUCCESS,
  SET_AGENDA_DETAILS_LOADING,
  CLEAR_AGENDA_REDUCER,
} from '../constants/ActionTypes';

export const getAgendaList = (studentId, date = moment().format('YYYY-MM-DD')) => ({
  type: GET_AGENDA_LIST,
  payload: { studentId, date },
});

export const getAgendaListSuccess = ({ items, date }) => ({
  type: GET_AGENDA_LIST_SUCCESS,
  payload: { list: items, date },
});

export const setAgendaListLoading = isLoading => ({
  type: SET_AGENDA_LIST_LOADING,
  payload: { isLoading },
});

export const getAgendaDetails = (studentId, date, routeId) => ({
  type: GET_AGENDA_DETAILS,
  payload: { studentId, date, routeId },
});

export const getAgendaDetailsSuccess = (details, date) => ({
  type: GET_AGENDA_DETAILS_SUCCESS,
  payload: { details, date },
});

export const setAgendaDetailsLoading = isLoading => ({
  type: SET_AGENDA_DETAILS_LOADING,
  payload: { isLoading },
});

export const clearAgendaReducer = () => ({
  type: CLEAR_AGENDA_REDUCER,
});
